// extracted by mini-css-extract-plugin
export var copyableField = "_pb-4";
export var customerBadge = "_pb-0";
export var customerInfoTitle = "_pb-2";
export var details = "_pb-1";
export var dropdownContainer = "_pb-5";
export var dropdownImage = "_pb-6";
export var editAssigneeForm = "_pb-a";
export var editButton = "_pb-3";
export var email = "_pb-7";
export var hidden = "_pb-d";
export var input = "_pb-8";
export var saveButton = "_pb-b";
export var shopifyIcon = "_pb-c";
export var suggestionBadge = "_pb-e";
export var suggestionText = "_pb-f";
export var username = "_pb-9";